import { Button, Card, Spinner } from 'flowbite-react'
import { useFormik } from 'formik'
import { type ExportFiltersValues } from '@app-types/stores/exports'
import { type AvailableExportGame } from '@app-types/api/exports'
import ExportFormatSelect from '@components/exports/ExportFormatSelect'
import GamesMultiSelect from '@components/exports/GamesMultiSelect'
import GroupingSelect from '@components/exports/GroupingSelect'
import PlayerFilterSelect from '@components/exports/PlayerFilterSelect'

interface ExportFiltersProps {
  availableGames: AvailableExportGame[]
  isStarting: boolean
  values: ExportFiltersValues
  onChange: (next: ExportFiltersValues) => void
  onSubmit: (values: ExportFiltersValues) => Promise<void> | void
}

function ExportFilters({
  availableGames,
  isStarting,
  values,
  onChange,
  onSubmit,
}: ExportFiltersProps) {
  const formik = useFormik<ExportFiltersValues>({
    initialValues: values,
    enableReinitialize: true,
    onSubmit: async (nextValues) => {
      await onSubmit(nextValues)
    },
  })

  function setNextValues(nextValues: ExportFiltersValues) {
    void formik.setValues(nextValues)
    onChange(nextValues)
  }

  return (
    <Card>
      <form className="grid gap-5" onSubmit={formik.handleSubmit}>
        <GamesMultiSelect
          availableGames={availableGames}
          games={formik.values.games}
          onChange={(games) => {
            setNextValues({
              ...formik.values,
              games,
            })
          }}
        />

        <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-[1fr_1.4fr_1fr_auto]">
          <PlayerFilterSelect
            value={formik.values.playerFilter}
            onChange={(playerFilter) => {
              setNextValues({
                ...formik.values,
                playerFilter,
              })
            }}
          />
          <ExportFormatSelect
            value={formik.values.exportFormat}
            onChange={(exportFormat) => {
              setNextValues({
                ...formik.values,
                exportFormat,
              })
            }}
          />
          <GroupingSelect
            value={formik.values.grouping}
            onChange={(grouping) => {
              setNextValues({
                ...formik.values,
                grouping,
              })
            }}
          />

          <div className="flex items-end">
            <Button
              className="w-full whitespace-nowrap"
              disabled={formik.values.games.length === 0 || isStarting}
              type="submit"
            >
              {isStarting ? <Spinner size="sm" className="mr-2" /> : null}
              Начать выгрузку
            </Button>
          </div>
        </div>
      </form>
    </Card>
  )
}

export default ExportFilters
